import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const inlineEditTitleEditViewEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "async-inline-edit-project-title" */ './InlineEditTitleEditView'
		).then((module) => module.InlineEditTitleEditViewEntryPoint),
	),
	getPreloadProps: () => ({}),
});
